export default __webpack_public_path__ + "static/media/imgpost4.4f36f65e.jpg";